export default __webpack_public_path__ + "static/media/logo.073b0a2a.svg";